import { Http } from '../../../support';
import ListItemHighlight from '../../../shared/support/ListItemHighlight';

const initialState = {
  busy: false,
  data: [],
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const highlight = (store, data) => {
  const { data: empresas } = store.state.app.empresas.list;

  const tool = new ListItemHighlight(empresas);

  store.setState((state) => {
    state.app.empresas.list.data = tool.getNewList(data, true);
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.empresas.list.busy = true;
  });

  try {
    const params = {
      ...meta,
    };

    const response = await Http.get('api/empresas', { params });

    store.setState((state) => {
      state.app.empresas.list.busy = false;
      state.app.empresas.list.data = response.data;
      state.app.empresas.list.pagination = {
        ...state.app.empresas.list.pagination,
        ...response.meta.pagination,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.empresas.list.error = error.data || error;
      state.app.empresas.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.empresas.list.error = undefined;
};

const reset = (store) => (state) => {
  state.app.empresas.list = {
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  };
};

const actions = {
  highlight,
  paginate,
  resetError,
  reset,
};

const EmpresasListStore = {
  state: () => ({
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  }),
  actions,
};

export default EmpresasListStore;
